import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DropdownComponent } from './dropdown.component';
import { DropdownMenuComponent } from './dropdown-menu.component';
import { DropdownToggleComponent } from './dropdown-toggle.component';

const components = [DropdownComponent, DropdownMenuComponent, DropdownToggleComponent];

@NgModule({
    imports: [CommonModule],
    declarations: components,
    exports: components
})
export class DropdownModule {}
